import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalDateTime, ZoneId, ZoneOffset } from '@js-joda/core';
import { IsOptional } from 'class-validator';
import { Timecode } from '../../type/shared';
/**
 * A generic type representing a uniquely identifiable, timecoded segment of a recording that resides in some system,
 * such as TRM files or StreamingSession.
 */
export class RecordingSegment {
}
__decorate([
    Serialize(),
    __metadata("design:type", LocalDateTime
    /**
     * The ZoneId of the recording PC.
     */
    )
], RecordingSegment.prototype, "startDateTime", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZoneId
    /**
     * @deprecated Use zoneId instead
     * The ZoneOffset of the recording PC, used as Web does not have access to @js-joda/timezone
     */
    )
], RecordingSegment.prototype, "zoneId", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZoneOffset
    /**
     * Timecode for the time period covered by this segment within the recording.
     */
    )
], RecordingSegment.prototype, "zoneOffset", void 0);
__decorate([
    Type(() => Timecode),
    __metadata("design:type", Object)
], RecordingSegment.prototype, "timecode", void 0);
__decorate([
    Serialize(),
    IsOptional(),
    __metadata("design:type", Set)
], RecordingSegment.prototype, "tags", void 0);
